import { CHANNELS, ReduxActionType } from 'types';

type ActionTypes = {
  FETCH_REFERRAL_CHANNELS_START: ReduxActionType;
  FETCH_REFERRAL_CHANNELS_SUCCESS: ReduxActionType;
  FETCH_REFERRAL_CHANNELS_FAILURE: ReduxActionType;
  DRAFT_REFERRAL_CHANNELS_START: ReduxActionType;
  DRAFT_REFERRAL_CHANNELS_SUCCESS: ReduxActionType;
  DRAFT_REFERRAL_CHANNELS_FAILURE: ReduxActionType;
  UPDATE_REFERRAL_CHANNELS_START: ReduxActionType;
  UPDATE_REFERRAL_CHANNELS_SUCCESS: ReduxActionType;
  UPDATE_REFERRAL_CHANNELS_FAILURE: ReduxActionType;

  FETCH_GML_PROJECTION_START: ReduxActionType;
  FETCH_GML_PROJECTION_SUCCESS: ReduxActionType;
  FETCH_GML_PROJECTION_FAILURE: ReduxActionType;

  FETCH_ACTIVE_CHANNEL_START: ReduxActionType;
  FETCH_ACTIVE_CHANNEL_SUCCESS: ReduxActionType;
  FETCH_ACTIVE_CHANNEL_FAILURE: ReduxActionType;
};

export const ReferralChannelsActionTypes: ActionTypes = {
  FETCH_REFERRAL_CHANNELS_START: '@@FETCH_REFERRAL_CHANNELS_START',
  FETCH_REFERRAL_CHANNELS_SUCCESS: '@@FETCH_REFERRAL_CHANNELS_SUCCESS',
  FETCH_REFERRAL_CHANNELS_FAILURE: '@@FETCH_REFERRAL_CHANNELS_FAILURE',
  DRAFT_REFERRAL_CHANNELS_START: '@@DRAFT_REFERRAL_CHANNELS_START',
  DRAFT_REFERRAL_CHANNELS_SUCCESS: '@@DRAFT_REFERRAL_CHANNELS_SUCCESS',
  DRAFT_REFERRAL_CHANNELS_FAILURE: '@@DRAFT_REFERRAL_CHANNELS_FAILURE',
  UPDATE_REFERRAL_CHANNELS_START: '@@UPDATE_REFERRAL_CHANNELS_START',
  UPDATE_REFERRAL_CHANNELS_SUCCESS: '@@UPDATE_REFERRAL_CHANNELS_SUCCESS',
  UPDATE_REFERRAL_CHANNELS_FAILURE: '@@UPDATE_REFERRAL_CHANNELS_FAILURE',
  FETCH_GML_PROJECTION_START: '@@FETCH_GML_PROJECTION_START',
  FETCH_GML_PROJECTION_SUCCESS: '@@FETCH_GML_PROJECTION_SUCCESS',
  FETCH_GML_PROJECTION_FAILURE: '@@FETCH_GML_PROJECTION_FAILURE',
  FETCH_ACTIVE_CHANNEL_START: '@@FETCH_ACTIVE_CHANNEL_START',
  FETCH_ACTIVE_CHANNEL_SUCCESS: '@@FETCH_ACTIVE_CHANNEL_SUCCESS',
  FETCH_ACTIVE_CHANNEL_FAILURE: '@@FETCH_ACTIVE_CHANNEL_FAILURE'
};

export interface ReferralChannelsState {
  loading: boolean;
  acLoading: boolean;
  dcActivation?: boolean;
  error?: string | undefined;
  activeChannel?: ActiveChannelDataType | undefined | {};
  draftChannel?: DraftChannelDataType | undefined | {};
  gmlLoading?: boolean;
  gmlProjectionItems?: [];
  pausedReferralsCount: number;
  swxAutomateVerified?: boolean;
}

export interface CreateReferralChannelsState {
  loading: boolean;
  error: string | undefined;
  activeChannel: ActiveChannelDataType;
  draftChannel: DraftChannelDataType;
}

export interface ReferralChannelBody {
  status?: string;
  isSendingPaused?: boolean;
  WebhookConfiguration?: any;
}

export interface ReferralChannelParams {
  organisationId: number;
  channelId?: number;
  requestBody?: ReferralChannelBody | any;
}

export interface InitialEmailFormProps {
  name: string;
  configurationType?: string;
  channelType?: string;
  referralSummaryEmail: string;
  actionType?: string;
  isGifRequired?: boolean;
  isXmlRequired?: boolean;
  isKmlRequired?: boolean;
  isGmlRequired?: boolean;
  gmlVersion?: string;
  gmlProjection?: string;
  requireAttachment?: [];
  isSendingPaused?: boolean;
  isPdfRequired: boolean;
  isPrimaryContentRequired: boolean;
}

export interface LegacyEmailConfigurationType {
  isGifRequired?: boolean;
  isXmlRequired?: boolean;
  isKmlRequired?: boolean;
  isGmlRequired?: boolean;
  gmlVersion?: string | null;
  gmlProjection?: string;
  emailNormalEnquiries: string;
  emailEmergencyEnquiries: string;
  emailLargeScaleEnquiries: string;
  isPdfRequired?: boolean;
}

export interface WebHookConfigurationType {
  isGmlRequired?: boolean;
  gmlVersion?: string | null;
  gmlProjection?: string;
  clientKey: string;
  customHeaders: any;
  url: string;
}
export interface DraftChannelDataType {
  name?: string;
  status?: string;
  configurationType: string;
  referralSummaryEmail?: string;
  maxEnquiryArea?: number | null;
  LegacyEmailConfiguration?: LegacyEmailConfigurationType;
  submitting?: boolean;
  WebhookConfiguration?: WebHookConfigurationType;
  referralSummaryFrequency?: string;
  gmlProjection?: string;
  primaryContent?: referralChannelPrimaryContentOptions;
}

export interface ActiveChannelDataType {
  id?: number;
  name?: string;
  configurationType: string;
  status: string;
  referralSummaryEmail?: string;
  referralSummaryFrequency?: string;
  maxEnquiryArea?: number | null;
  LegacyEmailConfiguration?: LegacyEmailConfigurationType;
  updatedAt?: string;
  startedLiveAt?: string;
  submitting?: boolean;
  isSendingPaused?: boolean;
  pausedReferralsCount?: number;
  WebhookConfiguration?: initialWebHookDataTypes;
  primaryContent?: referralChannelPrimaryContentOptions;
}

export interface Referrals {
  id: string;
  icon: string | undefined;
  contact: string | null;
  assetowner: string;
  status: string;
  waittime?: number;
  referralId: number;
  externalId: any;
  contactPhoneNumber: string;
  contactEmergencyPhone?: string;
  contactEmail: string;
  name: string;
  organisationType: string;
}

export interface initialWebHookDataTypes {
  channelType?: string;
  actionType?: string;
  name: string;
  configurationType: string;
  referralSummaryEmail: string;
  referralSummaryFrequency: string;
  WebhookConfiguration?: {
    url: string;
    clientKey: string;
    customHeaders: any[];
  };
  gmlProjection: string;
  isSendingPaused?: boolean;
  url?: string;
  clientKey?: string;
  customHeaders?: [{ name: string; value: string }];
}

/* DATA intialisation */
export const initialEmailData: InitialEmailFormProps = {
  name: '',
  channelType: 'email',
  referralSummaryEmail: '',
  isGifRequired: false,
  isXmlRequired: false,
  isKmlRequired: false,
  isGmlRequired: false,
  gmlProjection: '',
  requireAttachment: undefined,
  isPdfRequired: false,
  isPrimaryContentRequired: false
};

export const initialWebHookData: initialWebHookDataTypes = {
  name: '',
  configurationType: CHANNELS.WEBHOOK,
  referralSummaryEmail: '',
  referralSummaryFrequency: 'NEVER',
  url: '',
  clientKey: '',
  customHeaders: [{ name: '', value: '' }],
  gmlProjection: ''
};

export interface initialSWXAutomateDataTypes {
  name: string;
  configurationType: string;
  referralSummaryEmail: string | null;
  referralSummaryFrequency: string;
  SmarterWXAutomateConfiguration?: {
    test: boolean;
  };
  maxEnquiryArea?: number;
  status?: string;
  primaryContent?: null;
}

export const initialSWXAutomateData: initialSWXAutomateDataTypes = {
  name: '',
  configurationType: CHANNELS.SWX_AUTOMATE,
  referralSummaryEmail: null,
  referralSummaryFrequency: 'NEVER',
  SmarterWXAutomateConfiguration: {
    test: false
  }
};

export interface referralChannelAdvancedOptions {
  maxEnquiryArea?: number;
  referralSummaryFrequency?: string;
  referralSummaryEmail?: string;
  isSummaryEmailsInvalid?: boolean;
  isMaxAreaInvalid?: boolean;
  splitEnquiries?: boolean;
  isExpandPanel?: boolean;
}

export interface referralChannelPrimaryContentOptions {
  filenameOption?: string;
  filenameValue?: string;
  webMap?: boolean;
  responseType?: string;
}
